'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function pickLanguageString(loc, locale) {
  var localizer = {};

  for (var k in loc) {
    if (!loc[k].hasOwnProperty(locale)) {
      throw new Error('\'' + locale + '\' is not a key in the given localization data.');
    }

    localizer[k] = loc[k][locale];
  }

  return localizer;
}

/**
 * @param {localizerData} data
 * @param {string} locale
 * localize takes a localizer data map and extracts 
 * the correct localization string based on locale
 */

function vasadu(data, locale) {
  if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object' || Array.isArray(data)) {
    throw new Error('Data is not a proper object.');
  }

  return pickLanguageString(data, locale);
}

exports.default = vasadu;


//////////////////
// WEBPACK FOOTER
// ./node_modules/vasadu/lib/vasadu.js
// module id = 335
// module chunks = 0